const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export const generateBreadCrumbFromPath = (path) => {
    const segments = path.split("/").filter((segment) => segment);
    const capitalizedSegments = segments.map(capitalizeFirstLetter);
    return capitalizedSegments;
};
export const generateBreadCrumbFromApi = (apiBreadCrumb) => {
    const items = apiBreadCrumb.reduce((acc, curr) => {
        return acc.concat(curr.items);
    }, []);
    return items.map((item) => ({
        label: item.label,
        url: item.url,
    }));
};
